import { TranslationModel } from "models/translation";
import { doPost } from "../request";

interface ExportResponse {
  base64: string;
}

interface PDFPRops {
  cover: boolean;
  user_per_page: boolean;
}

interface TimestampPDFProps extends PDFPRops {
  timestamp: Date | null;
  filter: string;
}

export const adminDoGetExportTimestampPdf = async (
  listUuid: string,
  translations: TranslationModel,
  props: TimestampPDFProps,
) => {
  const response = await doPost<ExportResponse>(
    `/admin/list/${listUuid}/export/pdf/timestamp`,
    { translations, ...props },
  );
  return response.base64;
};

interface TimerangePDFProps extends PDFPRops {
  timerange_from: Date;
  timerange_to: Date | null;
}

export const adminDoGetExportTimerangePdf = async (
  listUuid: string,
  translations: TranslationModel,
  props: TimerangePDFProps,
) => {
  const response = await doPost<ExportResponse>(
    `/admin/list/${listUuid}/export/pdf/timerange`,
    { translations, ...props },
  );
  return response.base64;
};
